module.exports = (__parcel__import__("4XLaJ")).then(() => parcelRequire('2geSQ'));